document.addEventListener("DOMContentLoaded", function () {
  const intervalId = setInterval(function () {
    const parentDiv = document.querySelector(".rc-subscription-details");
    const currentDiv = document.querySelector(".rc-subscription-details__button");

    if (parentDiv && currentDiv) {
      if (!document.querySelector(".pause-text")) {
        const el = document.createElement("span");
        el.innerText = "Pause or Cancel Anytime";
        el.classList.add("pause-text");
        parentDiv.insertBefore(el, currentDiv);
      }
      // Clear the interval once the span is added
      clearInterval(intervalId);
    }
  }, 1000); 
});




$(document).ready(function(){
  setTimeout(function(){
      let updatedPrice = $('.product-single__meta').find('.recharge-subscription-widget .rc-widget .rc-radio__input:checked');
      let appPrice = updatedPrice.closest('label').find('span .price-label').text();
      updatedPrice.closest('.product-single__meta').find('form button .product-price').text(appPrice);
      updatedPrice.closest('.product-single__meta').find('.product-block--price .product__price:not(.product__price--compare) .money').text(appPrice);
  },500);
   
});

$(document).on('change','.rc-radio__input',function(){
    // console.log('change');
   let priceText = $(this).closest('label').find('span').find('.price-label').text();
    // console.log(priceText);
    $(this).closest('.product-single__meta').find('form button .product-price').text(priceText);
    $(this).closest('.product-single__meta').find('.product-block--price .product__price:not(.product__price--compare) .money').text(priceText);
});

 $('.variant-input input[type="radio"]').change(function(){
   let onOtherVariant = $(this).closest('.product-single__meta').find('.recharge-subscription-widget .rc-widget .rc-radio__input:checked');
   setTimeout(function(){
     let price = onOtherVariant.closest('label').find('span .price-label').text();
     onOtherVariant.closest('.product-single__meta').find('form button .product-price').text(price);
     onOtherVariant.closest('.product-single__meta').find('.product-block--price .product__price:not(.product__price--compare) .money').text(price);
   },500)
  });

function updateBadge(){
  const isProductPage = document.querySelector(".product-form__input");
  if (!isProductPage) return;
   const reviewInterval = setInterval(function () {
    let reviews = $('.product-single__meta .stamped-product-reviews-badge .stamped-badge-caption').data('reviews');
    let reviews_label = $('.product-single__meta .stamped-product-reviews-badge .stamped-badge-caption').data('label');
    const number = reviews;
    const formattedNumber = number.toLocaleString(); 
    $('.product-single__meta .stamped-product-reviews-badge .stamped-badge-caption').text(`${formattedNumber } ${reviews_label}`);
     
     clearInterval(reviewInterval);
  }, 100); 
}
updateBadge();



// $(window).on('scroll', () => {
//   if (window.scrollY > 250) {
//   $('.announcementMain').addClass('sticky_bar');
//   }else{
//      $('.announcementMain').removeClass('sticky_bar');
//   }

// })


